//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util';
export default {
  data: function data() {
    return {
      dbData: ''
    };
  },
  mounted: function mounted() {
    this.load();
  },
  methods: {
    load: function load() {
      this.dbData = JSON.stringify(util.db.value(), null, 2);
    }
  }
};